import { render, staticRenderFns } from "./eg_tabs.vue?vue&type=template&id=68aeb586&scoped=true&"
import script from "./eg_tabs.vue?vue&type=script&lang=js&"
export * from "./eg_tabs.vue?vue&type=script&lang=js&"
import style0 from "./eg_tabs.vue?vue&type=style&index=0&id=68aeb586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aeb586",
  null
  
)

export default component.exports